export const NOT_LOGGED_IN_ERROR_MESSAGE = 'Not logged in'
